uniform vec2 resolution;
uniform float devicePixelRatio;
uniform float time;
varying vec2 vUv;

#pragma glslify: isWithinRangeSmoothed = require(../../shaders/is-within-range-smoothed) 

float sdBox(in vec2 p, in vec2 b) {
    vec2 d = abs(p) - b;
    return length(max(d, 0.0)) + min(max(d.x, d.y), 0.0);
}

float sdCircle(vec2 p, float r) {
    return length(p) - r;
}

mat2 rotate2d(float _angle){
    return mat2(cos(_angle),-sin(_angle),
                sin(_angle),cos(_angle));
}

// mat2 inverse(mat2 m) {
//   return mat2(m[1][1],-m[0][1],
//              -m[1][0], m[0][0]) / (m[0][0]*m[1][1] - m[0][1]*m[1][0]);
// }

vec3 box(vec3 color, vec2 p, vec3 boxColor, float boxSize) {
    float boxDist = sdBox(p, vec2(190.0, 240.0));
    float boxDelta = fwidth(boxDist);
    vec2 bOffset = vec2(cos(time * 0.001) * 400.0, sin(time * 0.001) * 400.0);
    p -= bOffset;
    float distanceFromBlurCircle = sdCircle(p, boxSize);
    p += bOffset;

    // remove abs to see the shape causing the effect
    float isBox = smoothstep(abs(distanceFromBlurCircle) + boxDelta, 0.0, boxDist);
    return mix(color, boxColor, isBox);
}

void main() {
    vec2 st = gl_FragCoord.xy / resolution.xy / devicePixelRatio;

    vec2 userResolution = resolution.xy / devicePixelRatio;
    vec2 p = vUv * userResolution;

    vec3 color = vec3(0.0);

    // Centre relative
    p -= userResolution / 2.0;

    color = box(color, p, vec3(0.28,0.69,0.93), 100.0);

    mat2 rotate;

    vec2 offset = vec2(sin(time * 0.001) * 100.0, sin(time * 0.001) * -180.0);

    p += offset;
    rotate = rotate2d(time * 0.0003);
    p = rotate * p;
    color = box(color, p, vec3(0.25,0.75,0.58), 100.0);
    p = inverse(rotate) * p;

    p -= offset;

    p += offset;
    rotate = rotate2d(time * 0.0003);
    p = rotate * p;
    color = box(color, p, vec3(0.92,0.55,0.36), 50.0);
    p = inverse(rotate) * p;
    p -= offset;


    p *= 0.8f;

    // Circle
    vec2 circleOffset = vec2(10.0, 10.0);
    p += circleOffset;
    vec3 circleColor = vec3(0.88,0.51,0.74);
    float cicleDistance = sdCircle(p, 100.0);
    float cicleDelta = fwidth(cicleDistance);
    offset = vec2(sin(time * 0.001) * 50.0, cos(time * 0.001) * 40.0);
    p -= offset;
    float distanceFromBlurCircle = sdCircle(p, 50.0);
    p += offset;
    float isCircle = smoothstep(abs(distanceFromBlurCircle) + cicleDelta, 0.0, cicleDistance);
    color = mix(color, circleColor, isCircle);
    p -= circleOffset;

    // Bottom left relative
    p += userResolution / 2.0;

    // Circle

    // Border
    // vec3 borderColor = vec3(0.98, 0.98, 0.82);
    // float borderThickness = 20.0;
    // float isBorder = isWithinRangeSmoothed(p, vec2(borderThickness), vec2(userResolution - borderThickness), 0.01);
    // color = mix(color, borderColor, 1.0 - isBorder);

    gl_FragColor = vec4(color, 1.0);
}